import { gql } from 'graphql-request'

export const SINCRONIZAR_USUARIOS = gql`
  mutation SincronizarUsuariosMutation {
    sincronizarUsuarios
  }
`
